import { render, staticRenderFns } from "./TestD.vue?vue&type=template&id=061e35fe&scoped=true&"
import script from "./TestD.vue?vue&type=script&lang=ts&"
export * from "./TestD.vue?vue&type=script&lang=ts&"
import style0 from "./TestD.vue?vue&type=style&index=0&id=061e35fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e35fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
